import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from '../../commons/Modal';
import Boton from '../../commons/Boton';
import FileUpload from '../../commons/FileUpload';
import File from '../app/File';
import { confirmacion, mensajeMini } from '../../commons/Mensajes';

import {
  patchImagenMaterialAction,
  closeModal,
} from '../../redux/actions/material.action';

import SaveIcon from '@material-ui/icons/Save';

const MaterialImage = () => {
  const [imagen, setImagen] = useState(null);
  const dispatch = useDispatch();
  const { selected, processing } = useSelector((state) => state.material);
  const empresa = useSelector((state) => state.app.currentUser.ie);
  return (
    <Modal
      title={`${selected.im ? 'Modificar' : 'Agregar'} imagen`}
      loading="files"
      processing={processing}
      onActions={() => (
        <Boton
          className="op-grabar"
          disabled={processing}
          icon={() => <SaveIcon />}
          tabIndex={21}
          onClick={() => {
            if (imagen === null) {
              mensajeMini('Seleccione una imagen');
            } else {
              confirmacion(
                `¿Desea guardar la imagen?`,
                `La imagen se asignara al producto y/o insumo ${selected.nm}`
              )
                .then(() =>
                  dispatch(patchImagenMaterialAction(selected, imagen))
                )
                .catch(() => {});
            }
          }}
        >
          Guardar imagen
        </Boton>
      )}
      closeWithoutConfirmation
      onClose={() => dispatch(closeModal())}
    >
      {selected.im && (
        <File
          filename={selected.im}
          dir={[empresa, 'PDT', selected.mt]}
          onClose={() => {}}
          showInline
        />
      )}
      <FileUpload
        label={`${selected.im ? 'Modificar' : 'Agregar'} imagen`}
        extensions={['jpg', 'jpeg', 'png']}
        onSelectedFile={(files) => {
          setImagen(files.length > 0 ? files[0].file : null);
        }}
      />
    </Modal>
  );
};

export default MaterialImage;
